import apiClient from './api';

export const insertSearchStat = (userId, browser) => apiClient.post(`/statistic/insert/search-stat`, { userId, browser });

// details : { notificationId, buttonId } pour préciser l'élément cliqué à
// l'intérieur de la tuile (notification RSAI, dossier de « Vos ressources »).
export const insertTileStat = (userId, tileId, details = {}) =>
    apiClient.post(`/statistic/insert/tile-stat`, { userId, tileId, ...details });

export const insertConnectionStat = (userId) => apiClient.post(`/statistic/insert/connection-stat`, { userId });

export const insertUserConnectionStat = (userId, at, endpoint) => apiClient.post(`/statistic/insert/user-connection-stat`, { userId, at, endpoint });

export const getUserConnectionStats = (page = 1, pageSize = 10) =>
  apiClient.get(`/statistic/get/user-connection-stats`, {
    params: { page, pageSize },
  });
